import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { Text } from '../Text';
import { theme } from '../theme';
import { Icon } from '../Icon';
export const Tag = ({ label, color, borderColor, bgColor, className, icon, iconColor, onClick, ...marginProps }) => (React.createElement(Wrapper, { "$bgColor": bgColor, className: className, "$borderColor": borderColor, ...marginProps, alignContent: "center", justifyContent: "center", onClick: onClick },
    icon && (React.createElement(TagIcon, { render: icon, color: iconColor, size: 16, "data-testid": `tag-icon-${icon}` })),
    React.createElement(TagText, { tag: "span", typo: "label", color: color }, label)));
const Wrapper = styled(Box) `
  background-color: ${({ $bgColor }) => $bgColor && theme.colors[$bgColor]};
  border: ${({ $borderColor }) => $borderColor && `1px solid ${theme.colors[$borderColor]}`};

  border-radius: 6px;
  padding: 4px 8px;

  height: 22px;

  box-sizing: border-box;
  display: inline-flex;
`;
const TagText = styled(Text) `
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
`;
const TagIcon = styled(Icon) `
  padding-right: 4px;
`;
//# sourceMappingURL=Tag.js.map